var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import User from '../User';
var UserStub = /** @class */ (function (_super) {
    __extends(UserStub, _super);
    function UserStub(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.id, id = _c === void 0 ? '10' : _c, _d = _b.username, username = _d === void 0 ? 'Kaizen Taro' : _d, _e = _b.email, email = _e === void 0 ? 'yuta.yamamoto@kaizenplatform.com' : _e, _f = _b.profileImageUrl, profileImageUrl = _f === void 0 ? 'https://randomuser.me/api/portraits/lego/2.jpg' : _f;
        return _super.call(this, { id: id, username: username, email: email, profileImageUrl: profileImageUrl }) || this;
    }
    return UserStub;
}(User));
export default UserStub;
